// extracted by mini-css-extract-plugin
export default {"root":"Promotion_root__n6o4n","container":"Promotion_container__hfs-4","logo":"Promotion_logo__-rFXg","text":"Promotion_text__zhIKK","sphere":"Promotion_sphere__pXH4O"};